import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ProgressIndicator, ProgressIndicatorSkeleton, ProgressStep } from '@carbon/react'
import { data } from '../../lib/api'
import { WorkflowHistory } from '../../lib/types'
import { formatDate } from '../../workflows/util'

type Props = {
    open: boolean
    onClose: () => void
    workflowId: number | undefined
    rowId: number | undefined,
    cycleId?: number | undefined
}
function WorkflowHistoryModal(props: Props) {
    const { open, onClose, workflowId, rowId, cycleId } = props
    const [notes, setNotes] = useState<WorkflowHistory[]>([])
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState('')



    useEffect(() => {
        const getWorkflowHistory = async (workflowId: number, rowId: number) => {
            try {
                setLoading(true)
                const result = await data.getHistory(workflowId, rowId, cycleId)
                setNotes(result)
                setLoading(false)
                setErr('')
            } catch (err: any) {
                console.log(err.message);
                setLoading(false)
                setErr(err.message || 'Some Error Occurred')
            }
        }
        if (open) {
            if (workflowId && rowId) {
                getWorkflowHistory(workflowId, rowId)
            }
        }
    }, [open, workflowId, rowId, cycleId])

    return (
        <Modal modalHeading="Notes History" passiveModal open={open} onRequestClose={onClose}>
            <ModalBody>
                {loading && <ProgressIndicatorSkeleton vertical />}
                {err && <div className='flex justify-center text-red-700'>{err}</div>}
                {!loading && !err && <ProgressIndicator vertical spaceEqually>
                    {notes.map(item =>
                        <ProgressStep className='progressStep' complete={!item.error} invalid={item.error} label={`${item.account.name} ${formatDate(item.createdAt)}`} secondaryLabel={item.notes} />
                    )}
                </ProgressIndicator>}

            </ModalBody>
        </Modal>
    )
}

export default WorkflowHistoryModal